// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2xQCV","emails":"CreateEditClinics_emails__1JH9Y","emailTagLabel":"CreateEditClinics_emailTagLabel__3-_SG"};